import React from "react";
import { Layout } from "react-admin";
import { AppLocationContext } from "@react-admin/ra-navigation";
import { settings } from "../../app";

import AppBar from "./AppBar";
import Menu from "./Menu";
import Breadcrumb from "./Breadcrumb";

const CustomLayout = ({ children, ...rest }) => (
  <AppLocationContext>
    <Layout {...rest} appBar={AppBar} menu={Menu}>
      {settings.useBreadcrumb ? <Breadcrumb /> : null}
      {children}
    </Layout>
  </AppLocationContext>
);

export default CustomLayout;
